import { render, staticRenderFns } from "./dash-layout.vue?vue&type=template&id=147c8af8&scoped=true"
import script from "./dash-layout.vue?vue&type=script&lang=js"
export * from "./dash-layout.vue?vue&type=script&lang=js"
import style0 from "./dash-layout.vue?vue&type=style&index=0&id=147c8af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c8af8",
  null
  
)

export default component.exports